import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Grid, List, Input, Table, Icon } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import moment from "moment";
import NoOrderHistory from "./NoOrderHistory";
import { useSelector, useDispatch } from 'react-redux'
import { setTriviaInfo } from "../store/TriviaRedux"
import { getOrders } from "../store/OrderRedux"
import searchicon from "../assets/home/searchicon.svg";
import StarButton from './StarButton'
import { Config } from '../common'

const OrderHistory = ({ isSearch, rank, contestid, singleTrivias }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()
  const history = useHistory();
  const [search, setSearch] = useState('')
  const timer = useRef();
  const token = useSelector((state) => state.auth.token)
  const orders = useSelector((state) => state.order.orders)

  useEffect(() => {
    dispatch(getOrders({ triviaId: contestid, token }))
  }, []);

  const handleSearch = (value) => {
    setSearch(value)
    let param = { triviaId: contestid, token }
    if (value) {
      param.name = value
    }
    clearInterval(timer.current);
    timer.current = setTimeout(() => {
      dispatch(getOrders(param))
    }, 500)
  }
  if (orders.length == 0) {
    return <NoOrderHistory />
  }

  return (
    <>
      {isSearch && (<div className="conten">
        <div className="input_box clearall">
          <div className="search_sec">
            <img className="searchicon" src={searchicon} />
            <Input value={search} onChange={(e) => handleSearch(e.target.value)} placeholder='Search' />
          </div>
        </div>
      </div>)}
      <div className="inner_bg destops">
        <div className="celebrity">
          <Table>
            <Table.Row>
              <Table.HeaderCell><h4>Order ID</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Date</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Timer</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>result</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Amount</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>summary</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>reward</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Invoice</h4></Table.HeaderCell>
            </Table.Row>
          </Table>
        </div>
        <div className="scrolls-y" style={{ height: 400 }}>
          <div className="text"></div>
          {orders.map((item, key) => <div key={key} className="amount">
            {rank && (<div className="top_list"><span>Complited</span></div>)}
            <Table>
              <Table.Row>
                <Table.HeaderCell><h4>#{item.code}</h4></Table.HeaderCell>
                <Table.HeaderCell><h4>{moment.utc(item.createdAt).format('Do MMM, YYYY')}</h4></Table.HeaderCell>
                <Table.HeaderCell><h4>{Config.parseDuration(item?.contestant?.timeTaken)}</h4></Table.HeaderCell>
                <Table.HeaderCell><h4>{item.contestant?.score}/{item.contestant?.questionBank.length} are correct</h4></Table.HeaderCell>
                <Table.HeaderCell><h4>₹ {item.entryFees}</h4></Table.HeaderCell>
                <Table.HeaderCell style={{ cursor: 'pointer' }} onClick={() => {
                  dispatch(setTriviaInfo(singleTrivias))
                  history.push(`/contesthistory/${item._id}`)
                }}><a>View Summary</a></Table.HeaderCell>
                <Table.HeaderCell><a onClick={() => {
                  history.push(`/rewards`)
                }}>View Reward</a></Table.HeaderCell>
                <Table.HeaderCell><a href="#">Download Invoice</a></Table.HeaderCell>
              </Table.Row>
            </Table>
          </div>)}
          <div className="text"></div>
        </div>
      </div>

      <div className="mobiles scrolls-y" style={{ height: 400 }}>
        {orders.map((item, key) => <div key={key} className="sarukhu mobiles">
          {rank && (<div className="top_list"><span>Complited</span></div>)}

          <div className="answered_date">
            <div className="answered_data_sec">
              <h5>{moment.utc(item?.contestant?.timeStarted).format('Do MMM YYYY')}</h5>
              <h5>{Config.parseDuration(item?.contestant?.timeTaken)}</h5>
            </div>
            <div className="answered_sec">
              <h5>#{item?.code}</h5>
              <h5>₹{item?.entryFees}</h5>
            </div>
          </div>
          <div className="answered">
            <h4>Your have answered <span>{item?.contestant?.score} out of {item?.contestant?.attemptedQuestions} </span> questions correctly !</h4>
          </div>
          <div className="answered answere_sec">
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <h3><a onClick={() => {
                     history.push(`/contesthistory/${item._id}`)
                  }}>View Summary</a></h3>
                </Grid.Column>
                <Grid.Column>
                  <h3><a href="#"> Download Invoice</a></h3>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
          <div className="answered_border"></div>
          <h5><a onClick={() => {
            history.push(`/rewards`)
          }}>View reward</a></h5>
        </div>)}

      </div>


    </>
  );
};



export default OrderHistory;
